export const NEAR_BOTTOM_THRESHOLD_PX = 80;

export function isNearBottom(
  container: HTMLElement | null,
  threshold = NEAR_BOTTOM_THRESHOLD_PX
): boolean {
  if (!container) return true;
  const { scrollTop, scrollHeight, clientHeight } = container;
  return scrollHeight - scrollTop - clientHeight <= threshold;
}

export function scrollContainerToBottom(
  container: HTMLElement | null,
  behavior: 'auto' | 'smooth' = 'auto'
): void {
  if (!container) return;
  const top = container.scrollHeight;
  if (behavior === 'smooth') {
    container.scrollTo({ top, behavior: 'smooth' });
  } else {
    container.scrollTop = top;
  }
}
